import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'

export class ImageGrid extends React.PureComponent<ImageGrid.Props, ImageGrid.State> {
  public static sectionId = 'imggrid';


  
  public render(): JSX.Element {

    const { section } = this.props.data

    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = section?.article?.settings?.allow_full_width_images

    const imageQuantity = Helpers.check(this, 'this.props.section.blocks.length') ? this.props.section.blocks.length : 1
    const classes = imageQuantity === 1 ? 'w-full' : 'w-full md:w-1/2 px-1-6 md:px-0'
    return (
      <section className={ `dynamic-image-grid mb-4-8 text-left w-full ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''}`}>
        <div className={'w-full md:w-5/6 mx-auto'}>          
          <div className={'w-full md:w-4/5 px-1-6 md:px-0-4 mx-auto flex flex-wrap'}>
            {this.props.section?.blocks.map((block, i) => {
              let imageSrc = block.settings?.src
              return (
                imageSrc 
                  ? <div key={i} className={`${classes} mb-1-6 last:mb-0 md:mb-0 ${this.props.section.blocks.length === 2 ? 'pl-0 pr-0 md:pl-1-2 md:pr-1-2 first:pl-0 last:pr-0': ''}`}>
                    <Snippets.Image
                      alt={`blog featured image ${i}`}
                      src={imageSrc}
                      ratio={'natural'}
                      className={''}
                    />
                  </div> 
                  : null
              )
            })}
          </div>
        </div>
      </section>
    )
  }
  
}

export namespace ImageGrid {
  export interface Options extends ShopifyNext.Section {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: ImageGrid.Options;
  }
  export interface ImageSettings {
    src: string;
  }
  export interface State {}
}